import { React } from 'react'
import { breakpoints, colors } from 'globalStyles'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Card } from 'react-bootstrap'
import SVGIcon from 'reusableComponents/SVGIcon'

const tableHeaderStyle = {
  display: 'table-cell',
  verticalAlign: 'middle',
  width: '42px',
}

const tableStyle = {
  fontWeight: '600px',
  textAlign: 'left',
  fontSize: '14px',
  lineHeight: '20px',
  display: 'table-cell',
}

const tableContentStyle = {
  color: colors.secondary_grey,
}

const tableSubContentStyle = {
  color: colors.web_text_black,
  wordBreak: 'break-all',
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
}

const StyledCard = styled(Card)`
  margin-top: 12px;
  background-color: ${colors.web_grey_light} !important;
  border: none !important;
  border-radius: 8px !important;
  height: auto !important;
  min-height: 64px !important;
  max-width: 298px !important;
  @media ${breakpoints.desktop} {
    max-width: 468px !important;
  }
`

const StyledDiv = styled.div`
  margin-top: 12px;
`

const PackagePreference = ({ preferenceItems }) => {
  return (
    <>
      {preferenceItems.map((item) => (
        <StyledCard>
          <StyledDiv>
            <div style={tableHeaderStyle}>
              <SVGIcon
                Icon={item.icon}
                size="lg"
                color={colors.secondary_grey}
                aria-label="icon"
                style={item.iconStyle}
              />
            </div>
            <div style={tableStyle}>
              <div style={tableContentStyle}>{item.title}</div>
              <div style={tableSubContentStyle}>{item.text}</div>
            </div>
          </StyledDiv>
        </StyledCard>
      ))}
    </>
  )
}

const preferenceItemsPropTypes = PropTypes.shape({
  icon: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  iconStyle: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
})

PackagePreference.propTypes = {
  preferenceItems: PropTypes.arrayOf(preferenceItemsPropTypes).isRequired,
}

export default PackagePreference
